import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { getVisibiliyValue, getGroupListData, getUserListData, loadVisibilitySys, getDocIndex, getBskIndex } from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { IndexedDbService } from '@service/indexeddb.service';

@Component({
    selector: 'app-list-results',
    templateUrl: './list-results.component.html',
    styleUrls: ['./list-results.component.scss'],
})
export class ListResultsComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public results = [];
    public groupList = [];
    public userList = [];
    public indexList = [];
    public systemList = [];
    public propertiesList = [];
    public propBskList = [];    
    public visibilityList: any[];

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    constructor(
        private api: ApiV6Service,
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        protected translate: TranslateService,
        private indexedDbService: IndexedDbService
    ) {
        super(translate);
        this.menu.display = true;
        this.visibilityList = [];
        this.listColumns = [
            { header: this.translate.instant('Name'), field: 'name' },
            { header: this.translate.instant('Visibility'), field: 'visibilityLabel' },
            { header: this.translate.instant('Desc'), field: 'description' },
        ];
        this.visibilityList = loadVisibilitySys(this.translate);
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        // this.visibilityList = VisibilityListSys;
        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.readResultsData());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.results = wRes.data.getResultList.data.map((item) => {
            item.name = item.label;
            item._label = item.label;
            item.reference = item.label;
            item.visibilityLabel = getVisibiliyValue(item);
            return item;
        });
        this.groupList = [...getGroupListData(wRes.data.getGroupList.GroupList)];
        this.userList = [...getUserListData(wRes.data.getUserList.UserList)];
        this.indexList = this.indexedDbService.variableStorage.Variable.filter((item) => {
            if (item.Name.substring(0, 4) !== 'sys_') {
                return item;
            }
        });
        this.systemList = this.indexedDbService.variableStorage.Variable.filter((item) => {
            if (item.Name.substring(0, 4) === 'sys_') {
                return item;
            }
        });
        this.propertiesList = getDocIndex(this.translate);
        this.propBskList = getBskIndex(this.translate);
    }

    private readResultsData() {
        return forkJoin([
            this.api.execUrlAction('getresults',''),
            this.api.execUrlAction('getuserlist', ''),
            this.api.execUrlAction('getgrouplist', '')]).pipe(
            map(([getResultList, getUserList, getGroupList]) => {
                return { getResultList, getUserList, getGroupList };
            })
        );
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        if (event.duplicate === true) {
            this.addTab(event);
        } else {
            this.update(event);
        }
    }

    private update(event) {
        this.results = this.results.map((item) => {
            if (item.id === event.data.entete.id) {
                item.label = event.data.entete.name;
                item.name = event.data.entete.name;
                item.reference = event.data.entete.name;
                item.visibility = event.data.entete.visibility;
                item.visibilityLabel = getVisibiliyValue(item);
                item._label = event.data.entete.name;
                item.description = event.data.entete.desc;
                return item;
            } else {
                return item;
            }
        });
        this.results = [...this.results];
        this.closeTab(event);
    }

    addTab(event) {
        this.results.push(event.data.entete);
        this.results = [...this.results];
        this.results = this.results.map((item) => {
            item.label = item.name;
            item._label = item.name;
            item.reference = item.name;
            item.visibilityLabel = getVisibiliyValue(item);
            return item;
        });
        if (event.duplicate === true) {
            this.closeTab(event);
        } else {
            this.closeTabsheet(this._event);
            this.index = this.index - 1;
        }
    }

    deleteTab(event) {
        this.results = this.results.filter((item) => {
            return item.id !== event.data.id;
        });
        this.results = [...this.results];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelD', {label: event.data.name}),
            () => {
                this.delete(event);
            }
        );
    }

    public async delete(event) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deleteresult', event.data.id ));
            this.deleteTab(event);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.reference);
        }
    }

    sortReference(event: any): void {}
}
